<script>
    export default {
        
    }
</script>

<template>
    <div class="column is-half-tablet is-one-third-desktop">
        <div class="card is-flex is-flex-direction-column">
            <div class="card-image is-clipped">
                <picture class="image is-skeleton">
                    <img width="400"
                         height="225"
                         alt="Placeholder image">
                </picture>
            </div>
            <div class="card-content is-flex-grow-1 is-flex is-flex-direction-column">
                <div class="tags mb-3">
                    <div class="tag is-skeleton">
                        Tag
                    </div>
                </div>
                <h3 class="title is-5 has-skeleton">
                    Title
                </h3>

                <div class="skeleton-lines">
                    <div />
                    <div />
                </div>
            </div>
        </div>
    </div>
</template>
